export const adminManagerRegEx = /^(admin|manager)$/;

export const notApprovedStatusRegEx = /^(DRAFT|SUBMITTED|PARTIALLY_APPROVED|PARTIALLY_DECLINED|DECLINED)$/;

export const internalTenantTypeRegEx = /^(sandbox|developer|sales_demo|debug)$/i;
